import { render, staticRenderFns } from "./ManagementTags.vue?vue&type=template&id=4b8fdc63&scoped=true&"
import script from "./ManagementTags.vue?vue&type=script&lang=js&"
export * from "./ManagementTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8fdc63",
  null
  
)

export default component.exports